import React from 'react';
import {ReportPage} from "./report-page";
import 'typeface-open-sans';

function App() {
    return (
        <>
            <div data-testid="report-page">
                <ReportPage></ReportPage>
            </div>
        </>
    );
}

export default App;
